// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    turnQuality: 0.7,
    thumbQuality: 0.8,
    //baseApi: 'http://testSocial.lupa.co/',
     baseApi: 'https://social.lupa.co.il/',
    //basePaymentApi:'https://paymentsv4-ui.lupa.co/online/',
    basePaymentApi: 'https://payments-online.lupa.co.il/',

    baseNewPaymentApi:'https://paymentsv4-api.lupa.co.il',

    baseNewPayment:'https://paymentsv4-ui.lupa.co.il',

    baseConnectApi: 'https://connect.lupa.co.il/',

    baseGooglePhotosApi: 'https://tiles-api.lupa.co.il/api/bridge-photos.aspx',
    // baseConnectApi: 'http://localhost:50117/',
    fallbackCoverColor: '#fff',
    httpInitDelay: 0,
    version: '1.7.0'
}; // baseApi: 'https://testsocial.lupa.co/', // fallbackCoverColor: "#f6f6f6",
